const PRODUCT_OPERATION = [
  {
    path: 'product-operation/product-code',
    name: 'ProductOperationProductCode',
    component: () => import('@/views/product-operation/product-code/index.vue'),
    meta: {
      title: '产品编码',
      icon: '',
      keepAlive: true,
    },
  },
  {
    path: 'product-operation/product-category',
    name: 'ProductOperationProductCategory',
    component: () => import('@/views/product-operation/product-category/index.vue'),
    meta: {
      title: '产品类目',
      icon: '',
      keepAlive: true,
    },
  },
  {
    path: 'product-operation/product-attribute',
    name: 'ProductOperationProductAttribute',
    component: () => import('@/views/product-operation/product-attribute/index.vue'),
    meta: {
      title: '产品属性',
      icon: '',
      keepAlive: true,
    },
  },
]
export default PRODUCT_OPERATION
